import { render, staticRenderFns } from "./PlanDetailRates.vue?vue&type=template&id=789246cc&lang=pug&"
import script from "./PlanDetailRates.vue?vue&type=script&lang=ts&"
export * from "./PlanDetailRates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports